/**
 * Segmented control / tab strip — pm-common-ui Tab interaction pattern, Flowline styling.
 */
interface Tab<T extends string> {
  id: T
  label: string
  count?: number
}

interface Props<T extends string> {
  tabs: Tab<T>[]
  value: T
  onChange: (id: T) => void
  ariaLabel?: string
}

export function SegmentedTabs<T extends string>({ tabs, value, onChange, ariaLabel }: Props<T>) {
  return (
    <div className="seg-tabs" role="tablist" aria-label={ariaLabel || 'Filters'}>
      {tabs.map((t) => {
        const selected = t.id === value
        return (
          <button
            key={t.id}
            type="button"
            role="tab"
            aria-selected={selected}
            className={`seg-tab${selected ? ' on' : ''}`}
            onClick={() => onChange(t.id)}
          >
            {t.label}
            {typeof t.count === 'number' ? <span className="seg-count">{t.count}</span> : null}
          </button>
        )
      })}
    </div>
  )
}
